import { getApiClient } from "@punchup/utils/apiRegistry";
import { Product } from "../../legacy/products";

export async function getProductsForSpecial(specialId: string) {
  return getApiClient()
    .get<{ data: Product[] }>(`/api/v2/user/specials/${specialId}/products`)
    .then((data) => data.data);
}

export async function getAllProductsForSpecial(specialId: string) {
  return getApiClient()
    .get<{ data: Product[] }>(`/api/v2/public/specials/${specialId}/products`)
    .then((data) => data.data);
}

export async function getProductsForCollection(
  collectionId: string | null | undefined
) {
  if (!collectionId) {
    return null;
  }

  return getApiClient()
    .get<{ data: Product[] }>(
      `/api/v2/public/products?collection_id=${collectionId}`
    )
    .then((data) => data.data);
}
